var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20 24v-4h-4v4h4zM32 4V0h4v4h-4zm4 10v-4H0v4h36zm-4 10v-4h4v4h-4zM16 0v4h4V0h-4zM0 24v-4h4v4H0zM4 0v4H0V0h4z"
  })));
}
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sLCUzY3N2ZyB3aWR0aD0nMjQnIGhlaWdodD0nMjQnIHZpZXdCb3g9JzAgMCAzNiAyNCcgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJyUzZSAlM2NwYXRoIGZpbGwtcnVsZT0nZXZlbm9kZCcgY2xpcC1ydWxlPSdldmVub2RkJyBkPSdNMjAgMjRWMjBIMTZ2NGg0Wk0zMiA0VjBoNHY0SDMyWm00IDEwVjEwSDB2NEgzNlpNMzIgMjRWMjBoNHY0SDMyWk0xNiAwdjRoNFYwSDE2Wk0wIDI0VjIwaDR2NEgwWk00IDB2NEgwVjBoNFonIC8lM2UgJTNjL3N2ZyUzZSI=";
export { SvgMatchInfoIcon as ReactComponent };